module.exports = __webpack_public_path__ + "img/OA-Logo mit Wappen.773cd8e3.svg";